import { render, staticRenderFns } from "./health-toExamine.vue?vue&type=template&id=cde23b1a&"
import script from "./health-toExamine.vue?vue&type=script&lang=js&"
export * from "./health-toExamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports